// Module
var code = "<div class=\"visible-selected has-select condensed remove-top-padding clearfix\" ng-show=\"row.groups.length\">\n    <div class=\"assignment-tags\">\n        <span class=\"tag\" ng-repeat=\"group in row.groups\" ng-bind=\"group\"></span>\n    </div>\n</div>\n";
// Exports
module.exports = code;